import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { uniqueId } from '@co-3/ctrl-ui/common';
import { ProductsService } from 'app/products/products.service';
import { DisplayPriceComponent } from '../display-price/display-price.component';

@Component({
    selector: 'app-variant-card',
    templateUrl: './variant-card.component.html',
    styleUrls: ['./variant-card.component.scss'],
    imports: [NgClass, NgStyle, DisplayPriceComponent, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VariantCardComponent implements OnInit {
    @Input()
    public title: string;
    @Input()
    public productSlug: string;
    @Input()
    public showPriceFrom: boolean = false;
    @Input()
    public price: number;
    @Input()
    public settlementPeriod: string;
    @Input()
    public iconPath: string;
    @Output()
    public selected: EventEmitter<string> = new EventEmitter<string>();

    public showBody: boolean = false;
    protected bodyId = uniqueId('variant-card-details-');

    private productService = inject(ProductsService);
    protected fullTitle: string;

    public ngOnInit(): void {
        this.fullTitle = this.productService.getBySlug(this.productSlug)?.fullTitle ?? this.title;
    }
}
